import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PerfilUsuarioService {
  private data = null;
  private url = environment.serviceApi;
  constructor(public http: Http) { }


  getPerfil(){
    return new Promise((resolve, reject) => {
        this.http.get(this.url + '/perfis')
          .map(res => res.json())
          .subscribe(data => {
            this.data = data;
            resolve(this.data);
          },
            err => {
              reject(err);
            });
      });
  }


  getPerfilEdit(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/perfis/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }


  getByUsuarioPerfil(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/perfis/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }


  criaPerfil(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/perfis', {
				usuario_perfil_nome: data.usuario_perfil_nome,
				cd_usuario_perfil_samu: data.cd_usuario_perfil_samu,
				usuario_perfil_status: data.usuario_perfil_status,
        usuario_exibir_regiao: data.usuario_exibir_regiao
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


  editaPerfil(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/perfis/' + data.usuario_perfil_id, {
				usuario_perfil_nome: data.usuario_perfil_nome,
				cd_usuario_perfil_samu: data.cd_usuario_perfil_samu,
				usuario_perfil_status: data.usuario_perfil_status,
        usuario_exibir_regiao: data.usuario_exibir_regiao
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


  getMenu(){
    return new Promise((resolve, reject) => {
        this.http.get(this.url + '/menu')
          .map(res => res.json())
          .subscribe(data => {
            this.data = data;
            resolve(this.data);
          },
            err => {
              reject(err);
            });
      });
  }


  getByMenuPai(){
    return new Promise((resolve, reject) => {
        this.http.get(this.url + '/menuPai')
          .map(res => res.json())
          .subscribe(data => {
            this.data = data;
            resolve(this.data);
          },
            err => {
              reject(err);
            });
      });
  }

  getByMenuPaiContaFilho(usuario_perfil_id){
    return new Promise((resolve, reject) => {
        this.http.get(this.url + '/menuPaiContaFilho/' + usuario_perfil_id)
          .map(res => res.json())
          .subscribe(data => {
            this.data = data;
            resolve(this.data);
          },
            err => {
              reject(err);
            });
      });
  }

  getByMenuFilho(menu_id_pai,usuario_perfil_id,usuario_perfil){
    return new Promise((resolve, reject) => {
        this.http.get(this.url + '/menuFilho/' + menu_id_pai + '/' + usuario_perfil_id + '/' + usuario_perfil)
          .map(res => res.json())
          .subscribe(data => {
            this.data = data;
            resolve(this.data);
          },
            err => {
              reject(err);
            });
      });
  }


  
  getByVerificaPermissaoMenu(usuario_perfil_id,menu_id){
    return new Promise((resolve, reject) => {
        this.http.get(this.url + '/menuPerfilAcesso/' + usuario_perfil_id + '/' + menu_id)
          .map(res => res.json())
          .subscribe(data => {
            this.data = data;
            resolve(this.data);
          },
            err => {
              reject(err);
            });
      });
  }


  getByVerificaPermissao(usuario_perfil_id,menu_id){
    return new Promise((resolve, reject) => {
        this.http.get(this.url + '/verificaPerfilAcesso/' + usuario_perfil_id + '/' + menu_id)
          .map(res => res.json())
          .subscribe(data => {
            this.data = data;
            resolve(this.data);
          },
            err => {
              reject(err);
            });
      });
  }



  setMenuPerfil(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/setMenuPerfil', {
				usuario_perfil_id: data.usuario_perfil_id,
				menu_id: data.menu_id,
				visualizar: data.visualizar,
        editar: data.editar
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


  apagaMenuPerfil(usuario_perfil_id,menu_id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/setMenuPerfil/' + usuario_perfil_id + '/' + menu_id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}



	editaPerfilUsuario(data) {
		return new Promise((resolve, reject) => {
			let params = {
				editar: data.editar,
				usuario_perfil_id: data.usuario_perfil_id,
				menu_id: data.menu_id,
        menu_perfil_id: data.menu_perfil_id
			};
			this.http.put(this.url + '/menuPerfilAtualizar/' + data.menu_perfil_id, params)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

  visualizarPerfilUsuario(data) {
		return new Promise((resolve, reject) => {
			let params = {
				visualizar: data.visualizar,
				usuario_perfil_id: data.usuario_perfil_id,
				menu_id: data.menu_id,
        menu_perfil_id: data.menu_perfil_id
			};
			this.http.put(this.url + '/menuPerfilAtualizar/' + data.menu_perfil_id, params)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


  //-- Apagar a baixo

  getGruposProdutoCadastro() {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/grupoprodutoCadastro')
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getGruposProduto() {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/grupoproduto')
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getGrupoProduto(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/grupoproduto/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  criaGrupoProduto(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/grupoproduto', {
				grupo_produto_nome: data.grupo_produto_nome,
				grupo_produto_lote: data.grupo_produto_lote,
				grupo_produto_lote_nome: data.grupo_produto_lote_nome,
				grupo_produto_data_validade: data.grupo_produto_data_validade,
				grupo_produto_status: data.grupo_produto_status
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaGrupoProduto(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/grupoproduto/' + data.grupo_produto_id, {
				grupo_produto_nome: data.grupo_produto_nome,
				grupo_produto_lote: data.grupo_produto_lote,
				grupo_produto_lote_nome: data.grupo_produto_lote_nome,
				grupo_produto_data_validade: data.grupo_produto_data_validade,
				grupo_produto_status: data.grupo_produto_status				
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaGrupoProduto(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/grupoproduto/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
